import { render, staticRenderFns } from "./SensorCard.vue?vue&type=template&id=70027780"
import script from "./SensorCard.vue?vue&type=script&lang=js"
export * from "./SensorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports